module.exports = __webpack_public_path__ + "img/newicon1on.8548e065.svg";